import React from "react";

const tools = [
  {
    name: "ADP",
    logo: "https://cdn.simpleicons.org/adp/FFFFFF",
    bg: "#D32F2F",
  },
  {
    name: "QuickBooks",
    logo: "https://cdn.simpleicons.org/intuit/FFFFFF",
    bg: "#2CA01C",
  },
  {
    name: "Excel",
    logo: "https://upload.wikimedia.org/wikipedia/commons/7/73/Microsoft_Excel_2013-2019_logo.svg",
    bg: "#217346",
  },
  {
    name: "Google Sheets",
    logo: "https://cdn.simpleicons.org/googlesheets/FFFFFF",
    bg: "#34A853",
  },
  {
    name: "Gusto",
    logo: "https://cdn.simpleicons.org/gusto/FFFFFF",
    bg: "#F45D48",
  },
  {
    name: "Paychex",
    logo: "https://cdn.simpleicons.org/paychex/FFFFFF",
    bg: "#0033A0",
  },
];

export default function PayrollAnimation() {
  return (
    <div className="wrapper">
      <div className="fade left" />
      <div className="fade right" />

      <div className="track">
        {[...tools, ...tools].map((tool, i) => (
          <div
            className="pill"
            key={i}
            style={{ backgroundColor: tool.bg }}
          >
            <img src={tool.logo} alt={tool.name} />
          </div>
        ))}
      </div>

      <style>{`
        .wrapper {
          position: relative;
          overflow: hidden;
          width: 100%;
          padding: 32px 0;
          background: #ffffff;
        }

        .track {
          display: flex;
          gap: 28px;
          width: max-content;
          animation: scroll 22s linear infinite;
        }

        .pill {
          width: 64px;
          height: 64px;
          min-width: 64px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow:
            0 4px 12px rgba(0,0,0,0.08),
            inset 0 0 0 1px rgba(255,255,255,0.15);
          transition: all 0.25s ease;
          cursor: default;
        }

        .pill:hover {
          transform: translateY(-4px) scale(1.05);
          box-shadow:
            0 10px 25px rgba(0,0,0,0.12),
            inset 0 0 0 1px rgba(255,255,255,0.2);
        }

        .pill img {
          width: 28px;
          height: 28px;
        }

        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }

        .fade {
          position: absolute;
          top: 0;
          width: 50px;
          height: 100%;
          z-index: 2;
          pointer-events: none;
        }

        .fade.left {
          left: 0;
          background: linear-gradient(to right, white, transparent);
        }

        .fade.right {
          right: 0;
          background: linear-gradient(to left, white, transparent);
        }
      `}</style>
    </div>
  );
}